/**
 * Aggiornamento dell'applicazione installata.
 *
 * Il service worker non sostituisce il codice da solo: farlo mentre un
 * cameriere prende un ordine gli farebbe perdere il lavoro. Però, se si aspetta
 * che tutte le schede siano chiuse, su un telefono l'aggiornamento può non
 * arrivare mai. La nuova versione viene quindi segnalata e applicata quando la
 * persona sceglie di farlo.
 */

type Listener = (available: boolean) => void;

let available = false;
let applyUpdate: (() => Promise<void>) | null = null;
const listeners = new Set<Listener>();

export function setUpdateAvailable(apply: () => Promise<void>): void {
  available = true;
  applyUpdate = apply;
  listeners.forEach((listener) => listener(true));
}

export function isUpdateAvailable(): boolean {
  return available;
}

export function subscribeToUpdate(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export async function installUpdate(): Promise<void> {
  if (applyUpdate) {
    await applyUpdate();
    return;
  }
  window.location.reload();
}
